import classNames from "classnames";
import { twMerge } from "tailwind-merge";

function classNamesMerge(
  mainClassNames: Parameters<typeof classNames> | string,
  mergeClassNames: Parameters<typeof classNames> | string
) {
  return twMerge(classNames(mainClassNames), classNames(mergeClassNames));
}

export { classNamesMerge, classNames, twMerge };
